
<template>
	<div class="min-h-screen w-full relative">
    <slot />
	</div>
</template>